// Client-side Mock API Adapter for BharatKosh MSME Loan
// Provides full zero-database offline demo functionality with LocalStorage persistence.

const INITIAL_SCHEMES = [
  {
    id: "sch-1",
    name: "Mukhyamantri Udyam Kranti Yojana (MMUKY)",
    code: "MMUKY",
    type: "Madhya Pradesh",
    nodal_department: "MSME Department, Government of MP",
    implementing_agency: "MP MSME Directorate / District Industry Centres",
    benefit_type: "Interest subsidy (3%) + guarantee fee reimbursement",
    max_benefit_amount: 5000000,
    collateral_rule: "Collateral-free bank loan ₹50K to ₹50L",
    eligible_business_types: ["new", "existing"],
    description: "Flagship MP State scheme for new & expanding enterprises with 3% annual interest subvention and CGTMSE guarantee fee coverage for up to 7 years.",
    official_source: "MP MSME Department Notification No. 12/2022",
    active: true,
    verified: true,
    version: "2.4"
  },
  {
    id: "sch-2",
    name: "CGTMSE Credit Guarantee Scheme",
    code: "CGTMSE",
    type: "Credit Guarantee",
    nodal_department: "Ministry of MSME / SIDBI",
    implementing_agency: "CGTMSE Trust",
    benefit_type: "Credit guarantee cover on collateral-free loans up to ₹5 Crore",
    max_benefit_amount: 50000000,
    collateral_rule: "Guaranteed collateral-free credit for Micro & Small enterprises",
    eligible_business_types: ["new", "existing"],
    description: "Credit Guarantee Fund Trust for Micro and Small Enterprises provides up to 85% credit guarantee cover for loans extended without third-party collateral.",
    official_source: "CGTMSE Circular No. 214/2024",
    active: true,
    verified: true,
    version: "3.1"
  },
  {
    id: "sch-3",
    name: "Pradhan Mantri MUDRA Yojana (PMMY)",
    code: "PMMY",
    type: "Central",
    nodal_department: "Ministry of Finance",
    implementing_agency: "MUDRA / Member Lending Institutions",
    benefit_type: "Collateral-free loan up to ₹20 Lakh (Tarun Plus)",
    max_benefit_amount: 2000000,
    collateral_rule: "100% collateral-free micro enterprise credit",
    eligible_business_types: ["new", "existing"],
    description: "Refinance support to banks and NBFCs for micro enterprise funding across Shishu (up to ₹50k), Kishore (₹50k-5L), Tarun (₹5L-10L), and Tarun Plus (₹10L-20L).",
    official_source: "Ministry of Finance Govt of India",
    active: true,
    verified: true,
    version: "1.9"
  },
  {
    id: "sch-4",
    name: "Prime Minister's Employment Generation Programme (PMEGP)",
    code: "PMEGP",
    type: "Central",
    nodal_department: "Ministry of MSME",
    implementing_agency: "KVIC / KVIB / DIC",
    benefit_type: "Margin money capital subsidy (15% - 35% of project cost)",
    max_benefit_amount: 5000000,
    collateral_rule: "Collateral-free up to ₹10 Lakh under CGTMSE",
    eligible_business_types: ["new"],
    description: "Credit-linked capital subsidy for setting up micro enterprises in manufacturing (up to ₹50L) and services (up to ₹20L) generating local rural & urban jobs.",
    official_source: "KVIC / Ministry of MSME",
    active: true,
    verified: true,
    version: "2.0"
  },
  {
    id: "sch-5",
    name: "Mukhyamantri Yuva Udyami Yojana (MMYUY)",
    code: "MMYUY",
    type: "Madhya Pradesh",
    nodal_department: "MSME Department, Government of MP",
    implementing_agency: "District Industry Centres (DIC)",
    benefit_type: "Margin money + 5% interest subsidy for 5 years",
    max_benefit_amount: 20000000,
    collateral_rule: "Bank finance backed by state margin money support",
    eligible_business_types: ["new"],
    description: "Empowers MP youths (18-40 years) with funding up to ₹2 Crore for setting up manufacturing or high-value service units.",
    official_source: "MP DIC Portal",
    active: true,
    verified: true,
    version: "1.5"
  }
];

const INITIAL_USERS = [
  { id: "usr-1", email: "borrower@bharatkosh.demo", name: "Rajesh Sharma", role: "borrower", mobile: "9876543210", enterprise: "Sharma Precision Engineering", district: "Indore", active: true },
  { id: "usr-2", email: "bankadmin@bharatkosh.demo", name: "Amita Verma", role: "bank_admin", mobile: "9876543211", institution: "Madhya Bharat Public Bank", active: true },
  { id: "usr-3", email: "rm@bharatkosh.demo", name: "Vikram Singh", role: "bank_rm", mobile: "9876543212", institution: "Madhya Bharat Public Bank (Indore Branch)", active: true },
  { id: "usr-4", email: "admin@bharatkosh.demo", name: "Platform Administrator", role: "platform_admin", mobile: "9876543213", department: "Credit Exchange Operations", active: true },
  { id: "usr-5", email: "facilitator@bharatkosh.demo", name: "CA Neha Jain", role: "facilitator", mobile: "9876543214", city: "Bhopal", active: true },
  { id: "usr-6", email: "government@bharatkosh.demo", name: "MSME Dept MP", role: "government", mobile: "9876543215", department: "Directorate of MSME, Vallabh Bhawan", active: true }
];

const INITIAL_APPLICATIONS = [
  {
    id: "APP-MP-2026-081",
    business_name: "Sharma Precision Engineering",
    constitution: "Private Limited",
    sector: "Engineering & Auto Components",
    district: "Indore",
    amount_requested: 3500000,
    purpose: "Machinery purchase & CNC expansion",
    status: "Credit appraisal",
    cgtmse_opt_in: true,
    preferred_lender: "Madhya Bharat Public Bank",
    readiness_band: "Bank Ready",
    readiness_score: 82,
    created_at: "2026-10-18T10:30:00Z",
    assigned_branch: "Indore Palasia SME Branch",
    assigned_rm: "Vikram Singh",
    subsidy_match: "MMUKY (3% Interest Subvention)"
  },
  {
    id: "APP-MP-2026-064",
    business_name: "Narmada Agro Processing LLP",
    constitution: "LLP",
    sector: "Food processing",
    district: "Hoshangabad (Narmadapuram)",
    amount_requested: 2000000,
    purpose: "Working capital for wheat processing",
    status: "Indicatively approved",
    cgtmse_opt_in: true,
    preferred_lender: "Narmada Commercial Bank",
    readiness_band: "Bank Ready",
    readiness_score: 79,
    created_at: "2026-10-12T14:15:00Z",
    assigned_branch: "Hoshangabad Main",
    assigned_rm: "Pooja Trivedi",
    subsidy_match: "PMEGP (25% Capital Subsidy)"
  },
  {
    id: "APP-MP-2026-039",
    business_name: "Malwa Herbal & Wellness Store",
    constitution: "Proprietorship",
    sector: "Retail & Wellness",
    district: "Ujjain",
    amount_requested: 950000,
    purpose: "Store expansion and billing POS",
    status: "Sanctioned",
    cgtmse_opt_in: true,
    preferred_lender: "Vindhya Small Finance Bank",
    readiness_band: "Bank Ready",
    readiness_score: 86,
    created_at: "2026-10-02T09:20:00Z",
    assigned_branch: "Ujjain Freeganj",
    assigned_rm: "Sanjay Joshi",
    subsidy_match: "PMMY Tarun"
  }
];

const INITIAL_LENDERS = [
  { id: "len-1", name: "Madhya Bharat Public Bank", code: "MBPB", type: "Public Sector Bank", active_schemes: ["CGTMSE", "MMUKY", "PMMY"], min_cibil: 680, tat_days: 7, active: true },
  { id: "len-2", name: "Narmada Commercial Bank", code: "NCB", type: "Public Sector Bank", active_schemes: ["CGTMSE", "PMEGP"], min_cibil: 675, tat_days: 9, active: true },
  { id: "len-3", name: "Vindhya Small Finance Bank", code: "VSFB", type: "Small Finance Bank", active_schemes: ["PMMY", "CGTMSE"], min_cibil: 650, tat_days: 5, active: true },
  { id: "len-4", name: "Central India Enterprise Bank", code: "CIEB", type: "Private Sector Bank", active_schemes: ["CGTMSE", "Stand-Up India"], min_cibil: 700, tat_days: 4, active: true },
  { id: "len-5", name: "Pragati MSME Finance NBFC", code: "PMF", type: "NBFC", active_schemes: ["CGTMSE"], min_cibil: 630, tat_days: 3, active: true }
];

const INITIAL_GRIEVANCES = [
  { id: "GRV-102", subject: "Branch query delay regarding GST ITC reconciliation", tracking_no: "GRV-2026-00102", borrower_name: "Rajesh Sharma", status: "In Progress", created_at: "2026-10-22T11:00:00Z", priority: "Medium" },
  { id: "GRV-098", subject: "Clarification on MMUKY interest subvention schedule", tracking_no: "GRV-2026-00098", borrower_name: "Pooja Malviya", status: "Resolved", created_at: "2026-10-14T15:30:00Z", priority: "Low" }
];

const INITIAL_AUDIT_LOGS = [
  { id: "aud-1", timestamp: "2026-10-29T16:50:00Z", actor: "Platform Admin", action: "SCHEME_UPDATE", target: "MMUKY", details: "Interest subsidy rate confirmed at 3% for FY 2026-27" },
  { id: "aud-2", timestamp: "2026-10-29T16:15:00Z", actor: "Bank Admin (MBPB)", action: "CREDIT_POLICY_UPDATED", target: "MBPB Micro Engine", details: "Turnaround SLA updated to 7 days" },
  { id: "aud-3", timestamp: "2026-10-29T15:40:00Z", actor: "Vikram Singh (RM)", action: "SANCTION_ISSUED", target: "APP-MP-2026-039", details: "Sanction letter ₹9.50 Lakh issued under PMMY Tarun" }
];

const INITIAL_MASTERS = {
  districts: [
    "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Dewas", "Satna",
    "Ratlam", "Rewa", "Chhindwara", "Shivpuri", "Vidisha", "Narmadapuram",
    "Khandwa", "Khargone", "Sehore", "Raisen", "Mandsaur", "Neemuch", "Dhar", "Katni",
    "Singrauli", "Damoh", "Chhatarpur", "Seoni", "Balaghat", "Betul", "Harda", "Burhanpur"
  ],
  industries: [
    "Precision Engineering & Auto Components",
    "Food Processing & Agri Logistics",
    "Pharmaceuticals & Healthcare",
    "Textiles & Garments",
    "Chemicals & Allied",
    "IT & Electronics",
    "Wood & Furniture",
    "Rubber & Plastics",
    "Retail & Trade",
    "Hospitality & Services"
  ],
  constitutions: [
    "Private Limited",
    "Proprietorship",
    "Partnership",
    "LLP",
    "Public Limited",
    "One Person Company"
  ],
  msme_categories: [
    "Micro (< ₹1 Cr investment, < ₹5 Cr turnover)",
    "Small (< ₹10 Cr investment, < ₹50 Cr turnover)",
    "Medium (< ₹50 Cr investment, < ₹250 Cr turnover)"
  ]
};

const INITIAL_BUSINESSES = [
  {
    id: "biz-1",
    user_id: "usr-1",
    profile_completion: 85,
    business_identity: {
      legal_business_name: "Sharma Precision Engineering Pvt Ltd",
      trade_name: "Sharma Tools",
      constitution: "Private Limited",
      udyam_number: "UDYAM-MP-08-0019284",
      pan: "ABCPS1234D",
      gstin: "23ABCPS1234D1Z5",
      district: "Indore",
      pin_code: "452015",
      industry: "Precision Engineering & Auto Components",
      msme_category: "Small (< ₹10 Cr investment, < ₹50 Cr turnover)",
      vintage_years: 6,
      employees: 28,
      women_owned: false,
      sc_st_owned: false,
      exporter: false,
      startup: true
    },
    promoter: {
      name: "Rajesh Sharma",
      role: "Managing Director",
      pan: "ABCPS1234D",
      mobile: "9876543210",
      experience_years: 14,
      credit_score_range: "750-800"
    },
    business_operations: {
      main_products: "CNC Precision Turned Parts, Automotive Gears",
      monthly_sales: 3500000,
      locations: 1,
      capacity_utilization: 75,
      customer_concentration: 30,
      supplier_concentration: 25
    },
    financial: {
      turnover_fy24: 42000000,
      turnover_fy23: 34000000,
      pat_fy24: 3800000,
      debt_equity: 1.2
    },
    banking: {
      primary_bank: "Madhya Bharat Public Bank",
      account_type: "Current Account",
      average_bank_balance: 1200000
    },
    gst: {
      gst_compliance_score: 95,
      gstr1_filed_on_time: true
    },
    existing_liabilities: [
      { lender: "Madhya Bharat Public Bank", facility: "Term Loan", outstanding: 4500000 }
    ],
    funding_requirement: {
      amount: 3500000,
      tenure_months: 60,
      facility_type: "Term Loan (Machinery Expansion)",
      purpose: "Procurement of 5-Axis CNC Milling Center"
    },
    collateral: [],
    scheme_attributes: {
      cgtmse_opt_in: true,
      mmuky_eligible: true
    },
    declarations: {
      no_willful_defaulter: true,
      accurate_data: true
    },
    consent_flags: {
      share_with_banks: true,
      fetch_gst_data: true
    },
    discoverability: {
      public_sector: true,
      private_sector: true,
      sfb: true,
      nbfc: false
    }
  }
];

// Helper to seed localStorage
function getStorage(key, initialVal) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      localStorage.setItem(key, JSON.stringify(initialVal));
      return initialVal;
    }
    return JSON.parse(raw);
  } catch (e) {
    return initialVal;
  }
}

function setStorage(key, val) {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch (e) {
    console.error("Storage error", e);
  }
}

// Intercept and resolve client-side mock requests
export async function handleMockRequest(config) {
  const method = (config.method || "get").toLowerCase();
  const url = (config.url || "").replace(/^https?:\/\/[^/]+/, "").replace(/^\/api/, "");

  // Small delay for realistic feel
  await new Promise((res) => setTimeout(res, 60));

  // --- AUTH ENDPOINTS ---
  if (url === "/auth/me") {
    const user = getStorage("bk_current_user", false);
    return { data: user, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- MASTERS & BUSINESSES (FINANCIAL PASSPORT) ---
  if (url === "/masters/all") {
    return { data: INITIAL_MASTERS, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/businesses") {
    const list = getStorage("bk_businesses", INITIAL_BUSINESSES);
    if (method === "get") {
      return { data: list, status: 200, statusText: "OK", headers: {}, config };
    }
    if (method === "post") {
      let payload = {};
      try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
      const newBiz = { id: "biz-" + Date.now(), ...payload };
      const updated = [newBiz, ...list];
      setStorage("bk_businesses", updated);
      return { data: newBiz, status: 201, statusText: "Created", headers: {}, config };
    }
  }

  if (url.startsWith("/businesses/") && url.includes("/assess-readiness")) {
    const assessment = {
      band: "Bank Ready",
      score: 84,
      scores: {
        statutory_compliance: 28,
        financial_health: 26,
        banking_vintage: 18,
        collateral_substitute: 12
      },
      weights: {
        statutory_compliance: 30,
        financial_health: 30,
        banking_vintage: 20,
        collateral_substitute: 20
      },
      strengths: ["Valid Udyam & GST compliance", "Strong operating turnover", "100% CGTMSE Guarantee match"],
      warnings: ["Operating margin improvement needed"],
      missing: [],
      recommended_actions: ["Opt in for MP MMUKY 3% interest subsidy", "Maintain quarterly GSTR reconciliation"],
      suitable_routes: ["CGTMSE-indicated route", "MP State scheme route", "Central government scheme"]
    };
    return { data: assessment, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/funding-requirements") {
    const list = getStorage("bk_funding_reqs", [
      {
        id: "fr-1",
        business_id: "biz-1",
        amount: 3500000,
        facility_type: "Term Loan + Cash Credit",
        tenure_months: 60,
        purpose: "CNC Machinery procurement & Raw Material working capital",
        created_at: new Date().toISOString()
      }
    ]);
    if (method === "get") return { data: list, status: 200, statusText: "OK", headers: {}, config };
    if (method === "post") {
      let payload = {};
      try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
      const newItem = { id: "fr-" + Date.now(), ...payload };
      const updated = [newItem, ...list];
      setStorage("bk_funding_reqs", updated);
      return { data: newItem, status: 201, statusText: "Created", headers: {}, config };
    }
  }

  if (url.includes("/routes")) {
    return {
      data: {
        routes: [
          "MP State scheme route",
          "CGTMSE-indicated route",
          "Regular bank term loan",
          "Working-capital facility"
        ]
      },
      status: 200,
      statusText: "OK",
      headers: {},
      config
    };
  }

  if (url.includes("/scheme-matches")) {
    const matches = [
      {
        scheme_id: "sch-1",
        scheme_code: "MMUKY",
        scheme_name: "Mukhyamantri Udyam Kranti Yojana (MMUKY)",
        scheme_type: "Madhya Pradesh State Scheme",
        benefit_type: "3% Annual Interest Subvention + CGTMSE Fee Reimbursement",
        max_benefit_amount: 5000000,
        match_percentage: 95,
        status: "Potential Match",
        matched: ["Valid MP Udyam Registration", "Age criteria met", "Turnover within MMUKY ceiling"],
        unmatched: []
      },
      {
        scheme_id: "sch-2",
        scheme_code: "CGTMSE",
        scheme_name: "CGTMSE Credit Guarantee Scheme",
        scheme_type: "Credit Guarantee Trust",
        benefit_type: "Up to 85% sovereign guarantee cover up to ₹5 Crore",
        max_benefit_amount: 50000000,
        match_percentage: 92,
        status: "Potential Match",
        matched: ["Manufacturing MSME", "Collateral-free requirement", "Active bank relationship"],
        unmatched: []
      },
      {
        scheme_id: "sch-3",
        scheme_code: "PMMY",
        scheme_name: "Pradhan Mantri MUDRA Yojana",
        scheme_type: "Central Scheme",
        benefit_type: "Collateral-free micro loans up to ₹20 Lakh",
        max_benefit_amount: 2000000,
        match_percentage: 85,
        status: "Partial Match",
        matched: ["Micro enterprise status", "No third party guarantee"],
        unmatched: ["Requested amount exceeds Tarun limit"]
      }
    ];
    return { data: matches, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/consents") {
    const consents = getStorage("bk_consents", [
      { id: "c-1", entity_name: "Madhya Bharat Public Bank", purpose: "Credit Appraisal & CIBIL Check", scope: "Full Passport", granted_at: "2026-10-20", status: "Active" },
      { id: "c-2", entity_name: "CGTMSE Trust", purpose: "Guarantee Coverage Issuance", scope: "Financial Statements", granted_at: "2026-10-22", status: "Active" },
      { id: "c-3", entity_name: "Directorate of MSME MP", purpose: "MMUKY 3% Subsidy Processing", scope: "Statutory Certificates", granted_at: "2026-10-25", status: "Active" }
    ]);
    return { data: consents, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/documents") {
    const docs = getStorage("bk_documents", [
      { id: "doc-1", document_type: "Udyam certificate", filename: "Udyam_Registration_Indore.pdf", size: 245000, verified: true, uploaded_at: "2026-10-18T10:00:00Z" },
      { id: "doc-2", document_type: "GST certificate", filename: "GST_Certificate_23ABCPS.pdf", size: 310000, verified: true, uploaded_at: "2026-10-18T10:05:00Z" },
      { id: "doc-3", document_type: "Audited financial statements", filename: "BalanceSheet_FY24.pdf", size: 1450000, verified: true, uploaded_at: "2026-10-19T14:30:00Z" }
    ]);
    return { data: docs, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/documents/upload") {
    let payload = {};
    try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
    const docs = getStorage("bk_documents", []);
    const newDoc = { id: "doc-" + Date.now(), document_type: payload.document_type || "Other", filename: payload.filename || "upload.pdf", size: payload.size || 100000, verified: true, uploaded_at: new Date().toISOString() };
    const updated = [newDoc, ...docs];
    setStorage("bk_documents", updated);
    return { data: newDoc, status: 201, statusText: "Created", headers: {}, config };
  }

  if (url === "/subsidy-tracking") {
    const subs = [
      { id: "sub-1", scheme_name: "MMUKY 3% Interest Subvention", sanction_ref: "MP-MMUKY-2026-904", annual_benefit: 105000, status: "Active Subvention", claim_cycle: "Quarterly Disbursed", last_credited: "2026-09-30" },
      { id: "sub-2", scheme_name: "CGTMSE Annual Guarantee Fee Coverage", sanction_ref: "CGTMSE-MP-4481", annual_benefit: 18500, status: "Reimbursed by State", claim_cycle: "Annual", last_credited: "2026-08-15" }
    ];
    return { data: subs, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url.startsWith("/businesses/")) {
    const list = getStorage("bk_businesses", INITIAL_BUSINESSES);
    let payload = {};
    try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
    const bizId = url.split("/")[2];
    const idx = list.findIndex((b) => b.id === bizId);
    if (idx >= 0) {
      list[idx] = { ...list[idx], ...payload };
    } else {
      list.push({ id: bizId, ...payload });
    }
    setStorage("bk_businesses", list);
    return { data: { id: bizId, ...payload }, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/auth/login") {
    let payload = {};
    try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
    const email = payload.email || "borrower@bharatkosh.demo";
    const found = INITIAL_USERS.find((u) => u.email.toLowerCase() === email.toLowerCase()) || {
      id: "usr-" + Date.now(),
      email: email,
      name: email.split("@")[0].replace(".", " "),
      role: "borrower",
      mobile: "9876543210",
      active: true
    };
    setStorage("bk_current_user", found);
    return { data: found, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/auth/register") {
    let payload = {};
    try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
    const newUser = {
      id: "usr-" + Date.now(),
      email: payload.email || "user@bharatkosh.demo",
      name: payload.name || "New MSME Promoter",
      role: payload.role || "borrower",
      mobile: payload.mobile || "9876543210",
      enterprise: payload.business_name || "New Enterprise",
      active: true
    };
    setStorage("bk_current_user", newUser);
    return { data: newUser, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/auth/logout") {
    setStorage("bk_current_user", false);
    return { data: { success: true }, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- SCHEMES (CMS) ---
  if (url === "/schemes" || url === "/admin/schemes") {
    const schemes = getStorage("bk_schemes", INITIAL_SCHEMES);
    if (method === "get") {
      return { data: schemes, status: 200, statusText: "OK", headers: {}, config };
    }
    if (method === "post") {
      let payload = {};
      try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
      const newScheme = {
        id: "sch-" + Date.now(),
        ...payload,
        active: payload.active !== false,
        verified: true,
        version: "1.0"
      };
      const updated = [newScheme, ...schemes];
      setStorage("bk_schemes", updated);
      return { data: newScheme, status: 201, statusText: "Created", headers: {}, config };
    }
  }

  if (url.startsWith("/admin/schemes/")) {
    const schemeId = url.replace("/admin/schemes/", "");
    const schemes = getStorage("bk_schemes", INITIAL_SCHEMES);
    if (method === "put") {
      let payload = {};
      try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
      const updated = schemes.map((s) => (s.id === schemeId || s.code === schemeId ? { ...s, ...payload } : s));
      setStorage("bk_schemes", updated);
      return { data: { id: schemeId, ...payload }, status: 200, statusText: "OK", headers: {}, config };
    }
    if (method === "delete") {
      const updated = schemes.filter((s) => s.id !== schemeId && s.code !== schemeId);
      setStorage("bk_schemes", updated);
      return { data: { success: true }, status: 200, statusText: "OK", headers: {}, config };
    }
  }

  // --- BORROWER & DASHBOARD SUMMARY ---
  if (url.includes("/reports/dashboard-summary") || url.includes("/borrower/summary")) {
    const summary = {
      profile_completion: 88,
      readiness_score: 82,
      readiness_band: "Bank Ready",
      active_applications: 2,
      lender_interests: 3,
      eligible_schemes: 5,
      total_sanctioned: 950000,
      total_applied: 4450000,
      cgtmse_covered_amount: 3500000,
      projected_interest_subsidy: 105000
    };
    return { data: summary, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- NOTIFICATIONS ---
  if (url.includes("/notifications")) {
    const notifs = [
      { id: "notif-1", title: "Lender interest received", body: "Madhya Bharat Public Bank viewed and expressed interest in your application.", created_at: "2026-10-29T11:00:00Z", unread: true },
      { id: "notif-2", title: "CGTMSE Guarantee In-Principle Approved", body: "Application APP-MP-2026-081 pre-qualified for 85% credit guarantee.", created_at: "2026-10-28T14:30:00Z", unread: false },
      { id: "notif-3", title: "Document Verified", body: "Udyam Registration Certificate & GST 3B verified automatically.", created_at: "2026-10-27T10:15:00Z", unread: false }
    ];
    return { data: notifs, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- APPLICATIONS ---
  if (url === "/applications" || url === "/bank/applications") {
    const apps = getStorage("bk_applications", INITIAL_APPLICATIONS);
    if (method === "get") {
      return { data: apps, status: 200, statusText: "OK", headers: {}, config };
    }
    if (method === "post") {
      let payload = {};
      try { payload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
      const newApp = {
        id: "APP-MP-2026-" + Math.floor(100 + Math.random() * 900),
        created_at: new Date().toISOString(),
        status: "Draft",
        ...payload
      };
      const updated = [newApp, ...apps];
      setStorage("bk_applications", updated);
      return { data: newApp, status: 201, statusText: "Created", headers: {}, config };
    }
  }

  if (url.startsWith("/applications/")) {
    const appId = url.replace("/applications/", "");
    const apps = getStorage("bk_applications", INITIAL_APPLICATIONS);
    const found = apps.find((a) => a.id === appId) || apps[0];
    return { data: found, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- LENDER INTERESTS & MARKETPLACE ---
  if (url.includes("/borrower/lender-interests") || url.includes("/bank/opportunities")) {
    const opps = [
      { id: "opp-1", business_name: "Sharma Precision Engineering", requested: 3500000, sector: "Engineering", district: "Indore", readiness: "Bank Ready", cgtmse: true, score: 82 },
      { id: "opp-2", business_name: "Narmada Agro Processing LLP", requested: 2000000, sector: "Food processing", district: "Narmadapuram", readiness: "Bank Ready", cgtmse: true, score: 79 },
      { id: "opp-3", business_name: "Vindhya Textiles & Garments", requested: 4500000, sector: "Textile", district: "Gwalior", readiness: "Conditionally Ready", cgtmse: true, score: 71 }
    ];
    return { data: opps, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- ADMIN USERS, LENDERS, GRIEVANCES, AUDIT ---
  if (url === "/admin/users") {
    const users = getStorage("bk_users", INITIAL_USERS);
    return { data: users, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/admin/lenders") {
    const lenders = getStorage("bk_lenders", INITIAL_LENDERS);
    return { data: lenders, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/admin/grievances" || url === "/borrower/grievances") {
    const grvs = getStorage("bk_grievances", INITIAL_GRIEVANCES);
    return { data: grvs, status: 200, statusText: "OK", headers: {}, config };
  }

  if (url === "/admin/audit") {
    const logs = getStorage("bk_audit_logs", INITIAL_AUDIT_LOGS);
    return { data: logs, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- GOVERNMENT DASHBOARD & MAP METRICS ---
  if (url.includes("/gov/") || url.includes("/district")) {
    const govData = {
      total_disbursed_cr: 1420.5,
      total_sanctioned_cr: 1890.2,
      active_applications_count: 8420,
      cgtmse_covered_ratio: 84.6,
      top_districts: [
        { name: "Indore", count: 1840, amount_cr: 340.5 },
        { name: "Bhopal", count: 1420, amount_cr: 280.2 },
        { name: "Jabalpur", count: 980, amount_cr: 165.8 },
        { name: "Gwalior", count: 790, amount_cr: 130.4 },
        { name: "Ujjain", count: 680, amount_cr: 110.1 }
      ]
    };
    return { data: govData, status: 200, statusText: "OK", headers: {}, config };
  }

  // --- GENERIC CATCH-ALL (Any other GET, POST, PUT, DELETE) ---
  if (method === "get") {
    return { data: [], status: 200, statusText: "OK", headers: {}, config };
  }

  let postPayload = {};
  try { postPayload = typeof config.data === "string" ? JSON.parse(config.data) : (config.data || {}); } catch (_) {}
  return {
    data: { success: true, message: "Saved successfully", id: "mock-" + Date.now(), ...postPayload },
    status: 200,
    statusText: "OK",
    headers: {},
    config
  };
}
